import "./LegalNotice.module.css";
import Header from "@/reusable_sections/Header";
import LegalInformation from "./sections/LegalInformation";
import TheTransparencyReport from "./sections/TheTransparencyReport";
import Footer from "@/reusable_sections/Footer";
export default function LegalNoticePage() {
  return <div>
      <Header />
      <LegalInformation />
      <TheTransparencyReport />
      <Footer />
    </div>;
}